import { render, staticRenderFns } from "./LanguagesDropdown.vue?vue&type=template&id=980503de&"
import script from "./LanguagesDropdown.vue?vue&type=script&lang=js&"
export * from "./LanguagesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports